<div *ngIf="trainingMode" class="training-mode-banner">
  *** TRAINING MODE — NOT A REAL TRANSACTION ***
</div>
